/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


function isPartiallyInView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if any part of the element is visible
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

function isFullyOutOfView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if element is entirely above or below the viewport
  return elementBottom <= viewportTop || elementTop >= viewportBottom;
}

function counterFun() {
  var $counter = $('#counter');
  if (!$counter.length) return;

  if (isPartiallyInView($counter)) {
    $('.count').each(function () {
      var $this = $(this);
      var countTo = parseInt($this.attr('data-count'), 10);

      if (!$this.hasClass('counted')) {
        $this.addClass('counted');
        $({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 2000,
            easing: 'swing',
            step: function () {
              $this.text(Math.floor(this.countNum));
            },
            complete: function () {
              $this.text(countTo);
            }
          }
        );
      }
    });
  } else if (isFullyOutOfView($counter)) {
    // Reset only when fully out of view
    $('.count').each(function () {
      $(this).removeClass('counted').text('0');
    });
  }
}
$(window).on('scroll resize', counterFun);
$(document).ready(counterFun);

$(document).ready(function() {

  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }
  
  $('.testimonial-custom_row').slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows:false
        }
      }
    ]
  });

  $('.blog-post-custom_row').slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows:false
        }
      }
    ]
  });

  if (window.innerWidth >= 999) {
    $('.list-collections--grid .list-collections-slider').slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
      nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`
    });
  }


    $('.collection-slideshow-list').slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    speed: 500,
    slidesToScroll: 1,
    infinite: false
  });

   $('.logo-list-sec-iner').slick({
    dots: true,
    arrows: false,
    slidesToShow: 8,
    speed: 500,
    slidesToScroll: 1,
    infinite: false,
     responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 10
        }
      },
       {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

 $('.useful-links-list').slick({
    dots: true,
    arrows: false,
    slidesToShow: 3,
    speed: 1000,
    slidesToScroll: 1,
    infinite: false,
     responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

 $('.useful-video-list').slick({
    dots: true,
    arrows: false,
    slidesToShow: 3,
    speed: 1000,
    slidesToScroll: 1,
    infinite: false,
     responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

 $('.announcement-bar-sec-list').slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    speed: 1000,
    autoplay: true,
    slidesToScroll: 1,
    infinite: false
  });

  $('.pet-food-slider-list').slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '28%',
    speed: 500,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          centerPadding: '20%',
        }
      },
      {
        breakpoint: 740,
        settings: {
          centerPadding: '14%'
        }
      }
    ]
  });

  $('.featured-coll-list-list').slick({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    speed: 500,
    slidesToScroll: 1,
    prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    infinite: false,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  $('.make-real-food-list').slick({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    speed: 500,
    slidesToScroll: 1,
    prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>`,
    infinite: false,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  $(".featured-product-sec-media-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
  });
  
  $('.rm-content-text').click(function(e) {
    e.preventDefault();
    $('.rm-content_wrapper').toggleClass('active');
    if ($('.rm-content-text').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });

  $('body').on('click', '.byob_main_content .byob-step_progress-bar--item', function(){
    var closest = $(this).closest('.byob_main_content');
    $('.byob-step_progress-bar--item').removeClass('is-page-active');
    $(this).addClass('is-page-active');
    $('.byob-step_item').removeClass('is-active').hide();
    closest.find('.byob-step_item[step="'+$(this).attr('step')+'"]').addClass('is-active').show();
  });

  $(".ai-header").click(function(){
    $(this).toggleClass("active");
      $(".ai-content-wrapper").slideToggle();
  });

  $("body").on("click",".testimonial-custom_item-desc", function(){
    $(this).toggleClass("active");
  })

  const section1 = document.querySelector(".our-story-block-1");
  const section2 = document.querySelector(".our-story-block-2");
  const section3 = document.querySelector(".our-story-block-3");
  
  const dogImage1 = document.getElementById("out-story-dog-image");
  const dogImage2 = document.getElementById("out-story-dog-image-2");
  const dogImage3 = document.getElementById("out-story-dog-image-3");
  
  let isVisible1 = false;
  let isVisible2 = false;
  let isVisible3 = false;
  
  const startScroll = 0;
  
  window.addEventListener("scroll", function () {
    // --- Dog 1 ---
    if (section1 && dogImage1 && isVisible1) {
      const rect1 = section1.getBoundingClientRect();
      let maxProgress1 = 0.65;
      if (window.innerWidth <= 1350) {
        maxProgress1 = 0.55;
      } else if (window.innerWidth <= 1250) {
        maxProgress1 = 0.5;
      }
      const progress1 = Math.min(Math.max((startScroll + rect1.top) / (startScroll - rect1.height), 0), maxProgress1);
      const translateX1 = progress1 * 600;
      const translateY1 = progress1 * 200;
      dogImage1.style.transform = `translate(-${translateX1}px, ${translateY1}px)`;
    }
  
    // --- Dog 2 ---
    if (section2 && dogImage2 && isVisible2) {
      const rect2 = section2.getBoundingClientRect();
      const progress2 = Math.min(Math.max((startScroll - rect2.top) / (startScroll + rect2.height), 0), 0.85);
      const translateX2 = progress2 * 600;
      const translateY2 = progress2 * 200;
      dogImage2.style.transform = `translate(${translateX2}px, ${translateY2}px)`;
    }
  
    // --- Dog 3 ---
    if (section3 && dogImage3 && isVisible3) {
      const rect3 = section3.getBoundingClientRect();
      const progress3 = Math.min(Math.max((startScroll + rect3.top) / (startScroll - rect3.height), 0), 2.9);
      const translateX3 = progress3 * 500;
      const translateY3 = progress3 * 190;
      dogImage3.style.transform = `translate(-${translateX3}px, ${translateY3}px)`;
    }
  });

  function tabbingLeftScroll(){
    var prevAllElementWidth = 0;
    $('.sticky-product-list-category_link.active').parent().prevAll().each(function() {
        var elementWidth = $(this).outerWidth();
        prevAllElementWidth = prevAllElementWidth + elementWidth;
    });  
    var $scroller = $('.sticky-product-list-category');
    var divIdx = 4;    
    var scrollTo = prevAllElementWidth - 30
    $scroller.animate({'scrollLeft': scrollTo}, 000);
  }
  if($('.product-list-category').length > 0){
    var stckytop = $('.product-list-category').offset().top - $('.shopify-section--header').outerHeight() + $('.product-list-category').outerHeight();
    $(window).scroll(function(){
      if ($(window).scrollTop() >= stckytop) {
        $('.sticky-product-list-category').addClass('active');
      }else {
        $('.sticky-product-list-category').removeClass('active');
        
      }
    });
  }
  $('body').on('click','.product_with_tab a[href^="javascript:void(0)"]',function (e) {
    e.preventDefault();
    $('html').removeClass('lock-all');
    $('.sticky-product-list-category_link').removeClass('active');
    $('.product-list-category_link').removeClass('active');
    $(`a[href="javascript:void(0)"][data-tab="${$(this).attr('data-tab')}"]`).addClass('active');
    if($(this).hasClass('see-all-product_btn')){
      $('html, body').animate({
      scrollTop: 0
    }, 800);
    }else{
      $('html, body').animate({
        scrollTop: $($(this).attr('data-tab')).offset().top-150
      }, 800);  
    }
    
    window.location.hash = $(this).attr('data-tab');
    tabbingLeftScroll();
  });
  window.addEventListener('load', () => {
    console.log('page loaded');
    if(window.location.href.includes("#")){  
      $(`.product_with_tab a[href="javascript:void(0)"][data-tab="#${window.location.href.split("#")[1]}"]`).trigger("click");
    }
  });
  
  if($('.sticky-product-list-category_link.active').length > 0){
   setTimeout(function() { 
      tabbingLeftScroll();
    }, 1000); 
  }
  var lastId,
    topMenu = $(".sticky-product-list-category"),
    mainMenu = $(".product-list-category"),
    topMenuHeight = window.outerHeight - 150,
    menuItems = topMenu.find("a"),
    mainMenuItems = topMenu.find("a"),
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr("data-tab"));
      if (item.length) { return item; }
    });

  // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop()+topMenuHeight;
     
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
       if ($(this).offset().top < fromTop)
         return this;
     });
    // console.log('cur',cur);
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";
     console.log(lastId, id)
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         // menuItems.removeClass("active").parent().end().filter(`[href='#${id}']`).addClass("active");
         $('.product-list-category_link').removeClass("active");
         $(`.product-list-category_link[data-tab='#${id}']`).addClass("active");
       
         $('.sticky-product-list-category_link').removeClass("active");
         $(`.sticky-product-list-category_link[data-tab='#${id}']`).addClass("active");
         tabbingLeftScroll();
     }                   
  });
  
  
  // Observers
  if (section1) {
    new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          isVisible1 = entry.isIntersecting;
        });
      },
      { threshold: 0.1 }
    ).observe(section1);
  }
  
  if (section2) {
    new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          isVisible2 = entry.isIntersecting;
        });
      },
      { threshold: 0.1 }
    ).observe(section2);
  }
  
  if (section3) {
    new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          isVisible3 = entry.isIntersecting;
        });
      },
      { threshold: 0.1 }
    ).observe(section3);
  }

  function progressbarupdate(bundle_price){
    const el = document.querySelector('[data-progress-settings]');
    if(!el){
      return;
    }
    const settings = JSON.parse(el.textContent);
    console.log(settings);

    var barhtml = ``;
    var totalprice = parseInt(bundle_price / 100);
    var firstthreshold = parseInt(settings.firstthreshold.value);
    var secondthreshold = parseInt(settings.secondthreshold.value);
    var thirdthreshold = parseInt(settings.thirdthreshold.value);

    if(thirdthreshold){
      var progress = (totalprice * 100) / thirdthreshold;
      var checkpoint1 = (firstthreshold * 100) / thirdthreshold;
      var checkpoint2 = (secondthreshold * 100) / thirdthreshold;
      var checkpoint3 = (thirdthreshold * 100) / thirdthreshold;

      if(totalprice >= thirdthreshold){
        if(settings.success_message){
          barhtml += `<span class="shipping-notes-wrapper-text">${settings.success_message}</span>`;
        }
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: 100%">0</div>`;
        var discountedTotal = bundle_price - (bundle_price * (parseInt(settings.thirdthreshold.third_threshhold_number) / 100));
        var pricehtml = `<span class="price price--highlight">${formatMoney(discountedTotal, currencyFormat)}</span>
            <span class="price price--compare">${formatMoney(bundle_price, currencyFormat)}</span>
            <span class="save_percentage">(-${settings.thirdthreshold.third_threshhold_number}%)</span>`;

      }else if(totalprice >= secondthreshold){
        var first_ach = formatMoney((thirdthreshold * 100) - bundle_price, currencyFormat);
        if(settings.secondthreshold.second_threshhold_message){
          var thrmsg = settings.secondthreshold.second_threshhold_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${thrmsg.replace('[price]',first_ach)}</span>`;
        } 
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
        var discountedTotal = bundle_price - (bundle_price * (parseInt(settings.secondthreshold.second_threshhold_number) / 100));
        var pricehtml = `<span class="price price--highlight">${formatMoney(discountedTotal, currencyFormat)}</span>
            <span class="price price--compare">${formatMoney(bundle_price, currencyFormat)}</span>
            <span class="save_percentage">(-${settings.secondthreshold.second_threshhold_number}%)</span>`;

      }else if(totalprice >= firstthreshold){
        var first_ach = formatMoney((secondthreshold * 100) - bundle_price, currencyFormat);
        if(settings.firstthreshold.first_threshhold_message){
          var frstmsg = settings.firstthreshold.first_threshhold_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${frstmsg.replace('[price]',first_ach)}</span>`;
        }
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
        var discountedTotal = bundle_price - (bundle_price * (parseInt(settings.firstthreshold.first_threshhold_number) / 100));
        var pricehtml = `<span class="price price--highlight">${formatMoney(discountedTotal, currencyFormat)}</span>
            <span class="price price--compare">${formatMoney(bundle_price, currencyFormat)}</span>
            <span class="save_percentage">(-${settings.firstthreshold.first_threshhold_number}%)</span>`;
      }else{
        var first_ach = formatMoney((firstthreshold * 100) - bundle_price, currencyFormat);
        if(settings.default_message){
          var dftmsg = settings.default_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${dftmsg.replace('[price]',first_ach)}</span>`;
        }
        
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
      }
      barhtml += `<span class="check-point check-point-first  ${progress > checkpoint1 ? 'has_magenta' : ''}" style="left:${checkpoint1}%;">
        <span class="checkpoint-price text--xxsmall">${settings.firstthreshold.first_threshhold_short_message}</span>
      </span>
        <span class="check-point  ${progress > checkpoint2 ? 'has_magenta' : ''}" style="left:${checkpoint2}%;">
        <span class="checkpoint-price text--xxsmall">${settings.secondthreshold.second_threshhold_short_message}</span>
        </span> 
        <span class="check-point last-point  ${progress > checkpoint3 ? 'has_magenta' : ''}" style="left:${checkpoint3}%;">
        <span class="checkpoint-price text--xxsmall">${settings.thirdthreshold.third_threshhold_short_message}</span>
        </span> 
      </div>`;
    }else if(secondthreshold){
      var progress = (totalprice * 100) / thirdthreshold;
      var checkpoint1 = (firstthreshold * 100) / thirdthreshold;
      var checkpoint2 = (secondthreshold * 100) / thirdthreshold;      
      
      
      if(totalprice >= secondthreshold){
        var first_ach = formatMoney((thirdthreshold * 100) - bundle_price, currencyFormat);
        if(settings.secondthreshold.second_threshhold_message){
          var thrmsg = settings.secondthreshold.second_threshhold_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${thrmsg.replace('[price]',first_ach)}</span>`;
        }
        
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
      }else if(totalprice >= firstthreshold){
        var first_ach = formatMoney((secondthreshold * 100) - bundle_price, currencyFormat);
        if(settings.firstthreshold.first_threshhold_message){
          var frstmsg = settings.firstthreshold.first_threshhold_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${frstmsg.replace('[price]',first_ach)}</span>`;
        }
        
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
      }else{
        var first_ach = formatMoney((firstthreshold * 100) - bundle_price, currencyFormat);
        if(settings.default_message){
          var dftmsg = settings.default_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${dftmsg.replace('[price]',first_ach)}</span>`;
        }
        
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
      }
      barhtml += `<span class="check-point check-point-first  ${progress > checkpoint1 ? 'has_magenta' : ''}" style="left:${checkpoint1}%;">
      <span class="checkpoint-price text--xxsmall">${settings.firstthreshold.first_threshhold_short_message}</span>
      </span>
        <span class="check-point  ${progress > checkpoint2 ? 'has_magenta' : ''}" style="left:${checkpoint2}%;">
        <span class="checkpoint-price text--xxsmall">${settings.secondthreshold.second_threshhold_short_message}</span>
        </span> 
      </div>`;
    }else if(firstthreshold){
      var progress = (totalprice * 100) / thirdthreshold;
      var checkpoint1 = (firstthreshold * 100) / thirdthreshold;
      
      if(totalprice >= firstthreshold){
        var first_ach = formatMoney((secondthreshold * 100) - bundle_price, currencyFormat);
        if(settings.firstthreshold.first_threshhold_message){
          var frstmsg = settings.firstthreshold.first_threshhold_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${frstmsg.replace('[price]',first_ach)}</span>`;
        }
        
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
      }else{
        var first_ach = formatMoney((firstthreshold * 100) - bundle_price, currencyFormat);
        if(settings.default_message){
          var dftmsg = settings.default_message;
          barhtml += `<span class="shipping-notes-wrapper-text">${dftmsg.replace('[price]',first_ach)}</span>`;
        }
        
        barhtml += `<div class="shipiing-progress-track"><div class="shipping-progress-thumb" style="width: ${progress}%">0</div>`;
      }
      barhtml += `<span class="check-point check-point-first  ${progress > checkpoint1 ? 'has_magenta' : ''}" style="left:${checkpoint1}%;">
      <span class="checkpoint-price text--xxsmall">${settings.firstthreshold.first_threshhold_short_message}</span>
      </span></div>`;
    }

    $('[data-byob-shipping-bar]').html(barhtml);
    $('.bundle-preview_cart-prices .price-list').html(pricehtml);
    
  }
  var addedcnt = 0;
  var bundle_price = 0;
  var bundle_compare_price = 0;

  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  function activecheck(addedcnt,bundle_price,bundle_compare_price){
    if(addedcnt > 0){
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add to cart<svg width="18" height="18" class="icon icon--quick-buy-shopping-cart   " viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.592726 0.774894C1.04345 0.713177 2.05356 0.720973 2.51557 0.7645C2.80061 0.791136 3.00192 0.917169 3.12425 1.20302C3.37782 1.79745 3.48293 2.71476 3.76025 3.26827C3.83863 3.42484 3.96215 3.52943 4.12605 3.55022L14.4226 3.55737C14.8288 3.58985 15.1049 4.0537 14.9618 4.47468C14.346 6.23005 13.9475 8.17576 13.3079 9.90904C13.1844 10.2436 13.0585 10.4424 12.6999 10.4781L5.84224 10.4794C5.72288 10.497 5.59401 10.5769 5.53225 10.6925C5.46218 10.8238 5.32679 11.4507 5.35589 11.5904C5.38795 11.7437 5.58332 11.8658 5.7205 11.8736L13.438 11.8762C14.1286 12.0256 14.0942 13.1697 13.3822 13.2392H5.54176C4.83865 13.1573 4.25729 12.5648 4.11595 11.8106C3.96096 10.9823 4.5061 10.2631 4.29589 9.4374L2.17352 2.46984C2.12304 2.32497 1.99596 2.19764 1.85403 2.1697C1.38668 2.0768 0.547594 2.33991 0.196637 1.96896C-0.20539 1.54214 0.0499597 0.848955 0.592726 0.774894Z" fill="currentColor"></path>
        <path d="M4.17296 16.3133C2.9271 14.9504 4.95564 12.9748 6.0483 14.4404C7.07148 15.8131 5.29056 17.536 4.17296 16.3133Z" fill="currentColor"></path>
        <path d="M11.7741 16.3133C10.5282 14.9504 12.5567 12.9748 13.6494 14.4404C14.6726 15.8131 12.8917 17.536 11.7741 16.3133Z" fill="currentColor"></path>
      </svg></span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--gradient').removeClass('button--outline');
      $('.bundle-preview_cart-buttons').show();
    }else{
      $('.bundle-add_to_cart_button').html('Add To Box').addClass('button--outline').removeClass('readytoadd button--gradient');
      $('.bundle-preview_cart-buttons').hide();
    }
    $('.bundle-preview_cart-prices').attr('data-totalprice',bundle_price).find('.price-list').html(`<span class="price price--highlight">${formatMoney(bundle_price, currencyFormat)}</span>`);
    
    progressbarupdate(bundle_price);
    // if(addedcnt > 0){
    //   $('.bundle-preview_cart').show();
    // }else{
    //   $('.bundle-preview_cart').hide();
    // }
  }

  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    // bundle_compare_price += parseInt($(this).attr('data-compare_price'));
    bundle_price += parseInt($(this).attr('data-price'));
    var prevval = $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val();
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val(parseInt(prevval) + 1);

    activecheck(addedcnt,bundle_price,bundle_compare_price);     
    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--gradient').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 511.76 511.76" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M436.896 74.869c-99.84-99.819-262.208-99.819-362.048 0-99.797 99.819-99.797 262.229 0 362.048 49.92 49.899 115.477 74.837 181.035 74.837s131.093-24.939 181.013-74.837c99.819-99.818 99.819-262.229 0-362.048zm-75.435 256.448c8.341 8.341 8.341 21.824 0 30.165a21.275 21.275 0 0 1-15.083 6.251 21.277 21.277 0 0 1-15.083-6.251l-75.413-75.435-75.392 75.413a21.348 21.348 0 0 1-15.083 6.251 21.277 21.277 0 0 1-15.083-6.251c-8.341-8.341-8.341-21.845 0-30.165l75.392-75.413-75.413-75.413c-8.341-8.341-8.341-21.845 0-30.165 8.32-8.341 21.824-8.341 30.165 0l75.413 75.413 75.413-75.413c8.341-8.341 21.824-8.341 30.165 0 8.341 8.32 8.341 21.824 0 30.165l-75.413 75.413 75.415 75.435z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item" 
    data-thisqty="1"
    data-vid="${$(this).closest('.product-item').attr('data-variant-id')}"
    data-pid="${$(this).closest('.product-item').attr('data-product-id')}"
    data-price="${$(this).closest('.product-item').attr('data-product-price')}"
    data-compare_price="${parseInt($(this).attr('data-compare_price'))}"
    >
      <div class="bundle-preview_cart-item-wrapper">
        <img src="${featuredimage}" loading="lazy" width="50" height="50" alt="">
      </div>
      <div class="bundle_item_meta">
        <div class="bi_meta_wp">
          <div class="bi_meta_title">${$(this).closest('.product-item').attr('data-product-name')}</div>
          <div class="bi_price_wrapper">
            <div class="bi_meta_price">${formatMoney(parseInt($(this).attr('data-price')), currencyFormat)}</div>
            <div class="bi_meta_qty">x1</div>
          </div>
        </div>
        <div class="bundle-preview_car-item-remove link text--xsmall">
          Remove
        </div>
      </div>
      </div>`; 
    $('.bundle-preview_cart-items').append(itembox);
    $(this).hide().closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').show();
    // $('.bundle-preview_cart-item.hasblank').first().attr('data-vid',$(this).closest('.product-item').attr('data-variant-id')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').attr('data-product-price')).attr('data-compare_price',parseInt($(this).attr('data-compare_price'))).removeClass('hasblank');    
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:last-child', function(e){
    e.preventDefault();
    addedcnt += 1;
    var prevval = $(this).closest('.quantity-selector').find('input').val();
    // bundle_compare_price += parseInt($(this).attr('data-compare_price'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));

    activecheck(addedcnt,bundle_price,bundle_compare_price);
    $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-thisqty',prevval);
    $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"] .bi_meta_qty').html(`x${prevval}`);     
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:first-child', function(e){
    e.preventDefault();    
    addedcnt = addedcnt - 1;
    var prevval = parseInt($(this).closest('.quantity-selector').find('input').val());
    // bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-compare_price'));
    bundle_price = bundle_price - parseInt($(this).closest('.product-item').attr('data-product-price'));
    activecheck(addedcnt,bundle_price,bundle_compare_price); 
    if(prevval == 0){
      console.log('iffff');
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').remove();  
      $(this).closest('.quantity-selector').hide();
      $(this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
    }else{
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"] .bi_meta_qty').html(`x${prevval}`);     
    }
  });

  $('body').on('click','.bundle-preview_car-item-remove', function(){
    addedcnt = addedcnt - 1;
    // bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.bundle-preview_cart-item').attr('data-compare_price'));
    var totalbundleval = parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-thisqty'));
    
    bundle_price = bundle_price - totalbundleval;
    activecheck(addedcnt,bundle_price,bundle_compare_price); 
    $(this).closest('.bundle-preview_cart-item').remove();
    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta-wrapper .bundle-product-item__cta').show();
    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta-wrapper .quantity-selector').hide().find('input').val(0);
    
  });

  $('body').on('click','.link_to_view_details', function(){
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-added_contents').addClass('active');
    $('.bundle_preview_overlay').addClass('active');
  });

  $('body').on('click','.bundle-preview_cart-added_contents .popup-close', function(){
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-added_contents').removeClass('active');
    $('.bundle_preview_overlay').removeClass('active');
  });

  $('body').on('click','.bundle-add_to_cart_button.readytoadd ', function(){
    $(this).attr("aria-busy",true);
    var items = [];
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item').each(function(i,v){
       var val = $(this).attr('data-vid');         
       var qty = parseInt($(this).attr('data-thisqty'));
       items.push({
        quantity: qty,
        id: val
      });   
    });    
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
      $(this).removeAttr("aria-busy");
      $('.bundle-product-item__cta-wrapper').find('.quantity-selector').hide().find('.quantity-selector__input').val(0);
      $('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
      $('.bundle-preview_cart-items .bundle-preview_cart-item').remove();
      bundle_price = 0;
      activecheck(0,bundle_price,bundle_compare_price);     
    }.bind(this));  
    
  });
  
  // Click function
  $('.backed-ingredients_tabs--item_link').click(function(){
    $('.backed-ingredients_tabs--item_link').removeClass('active');
    $('.backed-ingredients_content').removeClass('active');
    $(this).addClass('active');
    
    var activeTab = $(this).attr('href');
    $(activeTab).addClass('active');
    return false;
  });

  $('.pdp-tabs_header--item_link').click(function(e){
    e.preventDefault();
    $('.pdp-tabs_header--item_link').removeClass('active');
    $(this).addClass('active');
    $('.pdp-tabs_content--item').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  // $('.pdp-tabs_accordion--item_link').click(function (e) {
  //   e.preventDefault();

  //   const $this = $(this);
  //   const $wrapper = $this
  //     .closest('.pdp-tabs_content--item')
  //     .find('.pdp-tabs_content--item_wrapper');

  //   if ($this.hasClass('active')) {
  //       // Close current open item
  //       $this.removeClass('active');
  //       $wrapper.slideUp();
  //   } else {
  //       // Close others
  //       $('.pdp-tabs_accordion--item_link').removeClass('active');
  //       $('.pdp-tabs_content--item_wrapper').slideUp();

  //       // Open current
  //       $this.addClass('active');
  //       $wrapper.slideDown();
  //   }
  // });
  if(window.matchMedia('(max-width: 767px)').matches){
    $('.pdp-tabs_content--item:not(:first-child)').find('.pdp-tabs_content--item_wrapper').hide();
    $('.pdp-tabs_accordion--item_link').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parents('.pdp-tabs_content--item').find('.pdp-tabs_content--item_wrapper').slideToggle();
    });
  }

  $(document).on('click', '.product-meta--custom_review', function(e) {
    e.preventDefault();

    var $target = $('#pdp-reviews');

    if ($target.length) {
      if(window.matchMedia('(max-width: 767px)').matches){
        $('html, body').animate({
            scrollTop: $target.offset().top - 80
        }, 600);
      }else{
        $('html, body').animate({
            scrollTop: $target.offset().top - 200
        }, 600);
      }
    }
  });
});
// ===============================================================================
/* ---------- Pincode EDD checker ---------- */
(() => {
  const ENDPOINT = 'https://blepestimateddelivery.ravi-e17.workers.dev/';

  const formatDate = (value) => {
    // Parse YYYY-MM-DD manually to avoid timezone shifts; fall back to native parsing
    const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    const date = m ? new Date(m[1], m[2] - 1, m[3]) : new Date(value);
    if (isNaN(date)) return value;

    const part = (opts) => date.toLocaleDateString('en-GB', opts);
    // return `${part({ weekday: 'long' })}, ${date.getDate()} ${part({ month: 'long' })} ${date.getFullYear()}`;
    return `${date.getDate()} ${part({ month: 'long' })} ${date.getFullYear()}`;
  };

  const check = async (checker) => {
    const input = checker.querySelector('#pincode-input');
    const button = checker.querySelector('.pincode-checker__submit');
    const result = checker.querySelector('.pincode-checker__result');
    const pincode = input.value.trim();

    if (pincode.length !== 6 || button.disabled) return;

    const show = (type, message) => {
      result.classList.remove('error', 'success');
      result.classList.add(type);
      result.innerHTML = message;
    };

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    result.classList.remove('error', 'success');
    result.innerHTML = '';

    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pincode })
      });
      const data = await res.json();

      if (!res.ok) throw new Error(data.detail || data.error);

      if (data.serviceable) {
        show('success', `Estimated delivery by <strong>${formatDate(data.etd)}</strong>`);
      } else {
        show('error', `Delivery not available for this pincode ${pincode}`);
      }
    } catch (err) {
      console.log(err);
      show('error', 'Unable to check right now. Please try again.');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  // Digits only, enable button at 6 digits
  document.addEventListener('input', (e) => {
    if (!e.target.matches('.pincode-checker #pincode-input')) return;

    const input = e.target;
    input.value = input.value.replace(/\D/g, '').slice(0, 6);
    input.closest('.pincode-checker').querySelector('.pincode-checker__submit').disabled = input.value.length !== 6;
  });

  // Button click
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.pincode-checker__submit');
    if (button) check(button.closest('.pincode-checker'));
  });

  // Enter key (stops form from reloading the page)
  document.addEventListener('submit', (e) => {
    if (!e.target.matches('.pincode-checker__row')) return;
    e.preventDefault();
    check(e.target.closest('.pincode-checker'));
  });
})();